import TablePagination from '@/components/common/Pagination/TablePagination';
import * as S from './style';
import { useGetRegisterInfoApi } from '@/api/conference';
import { downloadPdf } from '@/utils/fileUtils';
import ArrowLeftIcon from '@/components/Icon/ArrowLeftIcon';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const RegisterConfirm = () => {
	const navigate = useNavigate();

	const [page, setPage] = useState(1);

	const { data: registerInfoData } = useGetRegisterInfoApi({
		page: page,
		row: 10,
	});

	const handleBackButton = () => {
		navigate(-1);
	};

	return (
		<S.Container noData={registerInfoData?.register_info?.length === 0}>
			<S.BackButton onClick={handleBackButton}>
				<ArrowLeftIcon iconColor="#01337D" width="16" height="16" />
				<span>이전화면으로</span>
			</S.BackButton>
			{registerInfoData?.register_info?.length !== 0 ? (
				<TablePagination activePage={page} totalItems={registerInfoData?.total_count} onChange={(page) => setPage(page)}>
					<S.TableBox>
						{registerInfoData?.register_info?.map((item, index) => (
							<S.TableItem key={index}>
								<S.TableContent>
									<p className="date">{item.pay_info_tran_date}</p>
									<p>{item.pay_info_goods_name}</p>
								</S.TableContent>
								<S.Button type="button" onClick={() => downloadPdf(item.pay_info_pk ?? '')}>
									영수증 확인
								</S.Button>
							</S.TableItem>
						))}
					</S.TableBox>
				</TablePagination>
			) : (
				<S.NoData>등록 내역이 없습니다.</S.NoData>
			)}
		</S.Container>
	);
};
export default RegisterConfirm;
